<template>
    <div class="footer">
      	<div class="row justify-content-between align-items-center">
	        <div class="col">
	          	<p class="text-center font-size-sm mb-0">© 2020 Cashouse Srl | P.IVA 03896251208</p>
	        </div>
      	</div>
    </div>
</template>

<script>
	export default {}
</script>